import { Button } from "@components/Button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@components/Dialog";
import { Stack } from "@components/Stack";
import { Typography } from "@components/Typography";

export const PermissionDisabledDialog = ({ onClose, onSave }: { onClose: () => void; onSave: () => void }) => (
	<Dialog open={true} onOpenChange={onClose}>
		<DialogContent className="max-w-130 pb-5">
			<DialogHeader>
				<DialogTitle>Revoke access to my content</DialogTitle>
			</DialogHeader>

			<Typography size="sm" className="mb-5">
				I hereby acknowledge that by restricting access to my content I agree to lose an additional account traffic and
				stop my account promotion. Any content used for promotional purposes before this acknowledgment will be
				retained.
			</Typography>
			<Typography size="sm" color="msg_time" className="mb-5">
				Dreamcam will automatically stop using your content for marketing purposes on the next business day after you
				revoke your permission
			</Typography>
			<Typography size="sm" color="msg_time" className="mb-2">
				If you have any further questions, don&apos;t hesitate to contact us at hello@dreamcam.com
			</Typography>

			<Stack direction="row" spacing={8} wide className="gap-2">
				<Button onClick={onSave} wide>
					<Typography size="sm" type="span" weight="bold">
						Stop account promotion
					</Typography>
				</Button>
				<Button type="secondary" onClick={onClose} wide>
					<Typography size="sm" type="span" weight="bold">
						Cancel
					</Typography>
				</Button>
			</Stack>
		</DialogContent>
	</Dialog>
);
